import React, { useEffect, useRef, useState } from "react"
import { Modal } from "react-bootstrap"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { cancelOrder } from "services"
import { Button, Checkbox, TextField } from "components"
import classes from "./OhCanceledModal.module.scss"

const initialFormState = {
  cancelReasons: "",
  refundType: "cash"
}

const initialFormErrorsState = {
  cancelReasons: ""
}

const OhCanceledModal = props => {
  const {
    order,
    setOrders,
    showCancelModal,
    setShowCancelModal
  } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [form, setForm] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState(initialFormErrorsState)

  const unmount = useRef(false)

  const validate = () => {
    let result = true
    const errors = { ...initialFormErrorsState }

    if (form.cancelReasons.length > 300) {
      result = false
      errors.cancelReasons = t("دلیل_لغو_سفارش_طولانی_است")
    }

    setFormErrors(errors)

    return result
  }

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleClick = async () => {
    if (!validate()) return

    setSending(true)

    try {
      await cancelOrder(
        order._id,
        {
          refundType: form.refundType,
          cancelReasons: form.cancelReasons
        }
      )

      if (unmount.current) return

      setOrders(prev =>
        prev.map(o =>
          order._id === o._id ? { ...o, orderStatus: "canceled" } : o
        )
      )

      setShowCancelModal(false)

      toast.success(t("سفارش_کنسل_شد"))
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error(t("سفارش_با_موفقیت_کنسل_نشد"))
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  const canRefundToUserWallet =
    !!order.accountId &&
    order.orderStatus === "paid" &&
    order.accountRole === "user"

  return (
    <Modal
      show={showCancelModal}
      onHide={() => setShowCancelModal(false)}
      onExited={() => setSending(false)}
      centered
    >
      <div className={classes["container-modal"]}>
        <h4 className={classes["title"]}>
          {t("آیا_می_خواهید_این_سفارش_را_کنسل_کنید")}
        </h4>

        <TextField
          as="textarea"
          rows={3}
          type="text"
          label={t("دلیل_لغو_سفارش")}
          placeholder={t("دلیل_لغو_سفارش_را_وارد_کنید")}
          value={form.cancelReasons}
          error={formErrors.cancelReasons}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "cancelReasons")}
        />

        {
          canRefundToUserWallet &&
          <div className={classes["row"]}>
            <div className={classes["refund"]}>
              <Checkbox
                onChange={() => handleChange("cash", "refundType")}
                checked={form.refundType === "cash"}
              />
              <span className={classes["refund-text"]}>
                {t("بازپرداخت_به_صورت_نقدی")}
              </span>
            </div>

            <div className={classes["refund"]}>
              <Checkbox
                onChange={() => handleChange("wallet", "refundType")}
                checked={form.refundType === "wallet"}
              />
              <span className={classes["refund-text"]}>
                {t("بازپرداخت_به_کیف_پول_کاربر")}
              </span>
            </div>
          </div>
        }

        <div className={classes["buttons"]}>
          <Button
            className={classes["button"]}
            color="danger"
            disabled={sending}
            onClick={() => setShowCancelModal(false)}
          >
            {t("انصراف")}
          </Button>
          <Button
            color="success"
            loading={sending}
            onClick={handleClick}
          >
            {t("تایید")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default OhCanceledModal